import { csvRow } from '@oip/contracts';

/**
 * CSV serialisation for every grid export in the product, plus the download.
 *
 * ⚠️ **THIS HELD A PRIVATE `escapeCell` WITH TWO DEFECTS, and one of them was a
 * vulnerability.** It quoted `[",\n]` — so a BARE CR went through unquoted and
 * ended the record for a strict reader, putting everything after it in the wrong
 * column while the file still parsed. And it did no formula neutralisation at
 * all: a vehicle name, a geofence or a provider error beginning `=` became code
 * executing in whoever opened the export.
 *
 * ⚠️ **IT IS ONE RULE NOW, SHARED WITH THE REPORT GATEWAY**, because three
 * copies of a security control is the shape this codebase keeps paying for — and
 * the log store's own exporter already had it right, which is exactly how two
 * neighbours come to differ without anybody noticing. `@oip/contracts` is the
 * only package `apps/web` and `@oip/report-gateway` can both see.
 */
export function toCsv(headers: string[], rows: (string | number | null | undefined)[][]): string {
  return [csvRow(headers), ...rows.map(csvRow)].join('\r\n');
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
